export const GET_METRICS_AUTHORIZATION = 'GET_METRICS_AUTHORIZATION';
export const CLEAR_METRICS_AUTHORIZATION = 'CLEAR_METRICS_AUTHORIZATION';

export function getMetricsAuthorization() {
  return {
    type: GET_METRICS_AUTHORIZATION,
    api: {
      endpoint: ['metrics', 'getMetricsAuthorization'],
    },
  };
}

export function clearMetricsAuthState() {
  return { type: CLEAR_METRICS_AUTHORIZATION };
}
